import { render } from "./IconTrash.vue?vue&type=template&id=050de2ed"
import script from "./IconTrash.vue?vue&type=script&lang=ts"
export * from "./IconTrash.vue?vue&type=script&lang=ts"
script.render = render

export default script